<div class="relative">
  <!-- Input Label -->
  <app-label [label]="label" [required]="required" [for]="id"></app-label>

  <!-- Grave Type Select Input -->
  <div class="input-container">
    <select
      [id]="id"
      [name]="name"
      class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-arabic-green focus:border-arabic-green dark:bg-gray-700 dark:text-white"
      [ngClass]="{
        'border-red-500': formControl?.errors
      }"
      (change)="onSelectChange($event)"
      (blur)="onTouched()"
      [formControl]="formControl"
    >
      <option value="">
        {{ placeholder | translate }}
      </option>
      <option
        *ngFor="let graveType of graveTypes"
        [value]="graveType.zGraveTypeId"
      >
        {{
          translate.currentLang === "en" ? graveType.nameEn : graveType.nameAr
        }}
      </option>
    </select>
  </div>

  <!-- Error Message -->
  <div *ngIf="formControl" class="mt-1 text-sm text-red-600">
    <!-- Required validation -->
    <span *ngIf="formControl.errors?.['required'] && formControl.touched">
      {{ "VALIDATION.REQUIRED" | translate }}
    </span>
  </div>
</div>
